<template>
    <a href="/favourites" class="btn btn_lg btn_fav btn_icontext">
        <i class="f7-icons icon_lg">heart_circle</i><span class="d-none d-sm-inline">{{ count }}</span>
    </a>
</template>

<script>
    export default {
        computed: {
            count() {
                return this.$store.getters['favourites/count'];
            }
        },
    }
</script>
